import React, {Component} from 'react';
//import { withNavigation } from 'react-navigation'; // 画面遷移時に再描画するために必要 1/4

import { cf } from './c_20210415a_YSh/cf';
import { ce } from './c_20210415a_YSh/ce';
import { iv } from './c_20210415a_YSh/iv';
import { ic } from './c_20210415a_YSh/ic';
import { cp } from './c_20210415a_YSh/cp';
import { ip } from './c_20210415a_YSh/ip';
import { bf } from './c_20210415a_YSh/bf';

import cView from './c_20210415a_YSh/cView';

//class cCpyDtl extends React.Component{
class cCpyDtl extends cView{

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  $id_stss = {
    s_im10c310: '',
    s_im10cz10: '10', // 表示対象
    sp_upl: '',
  };

  $ilp_loads = () => [
    ip.$ip_load_im10({
      mode: 'set',
      b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
      im10_key: global.c.state.sgcd_pageCmns?.im10_key,
    })
    .then( () => new Promise(_o_end1 => {
      let _im10_key = cf.myNV_cpt_prms({
        im10_key: global.c.state.sgcd_pageCmns?.im10_key,
        sgc_pageRole: 'cast',
        sgc_pageName: 'iSrvDtl',
        sgc_pageMode: 'show',
      });

      global.c?.setState({
        sp_url: '{}/iSrvDtl?prms={}'.f(
          ic.g_url0, 
          _im10_key,
        ),
      }, () => {
        _o_end1();
      });
    })),
  ];

  $ip_ins = () => ip.$ip_ins_im10();

  $ilp_upds = () => [
    ip.$ip_upd_im10()
  ];

  $ild_onChgss = ip.ild_onChgss;

  $pld_onChgss = () => [
  ];

  render(){
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_rhtVsb={true}
        rhtPfx={null}
        onRhtPrs={null}
        d_hdrs={{
          pfx: iv._get_hdrPfx('バインダ情報'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_im10c310',
              pfx:'バインダ名',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb: (bf.n(global.c?.state.sgcd_pageCmns?.user_key) == -1) ? true : false,
              b_edt:true,
              state:'sp_url',
              pfx:'URL',
              b_mln:true,
            },
            {
              type:'Qr',
              b_vsb:true,
              val: global.c?.state.sp_url,
              pfx: 'QRコード',
            },
            {
              type:'Pck',
              b_vsb:(bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_im10cz10',
              pfx:'表示の有無',
              ld_itemss: [
                {key:'10', pfx: '表示する'},
                {key:'0', pfx: '表示しない'},
              ],
              b_setValOnChg:false,
            },
          ],
        }}
      />
    );
  }        
}

export default cCpyDtl;
